import React from 'react';
import { ArrowLeft, FileText, Scale } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const AGBPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-12">
        <div className="container mx-auto px-4">
          <Link to="/">
            <Button variant="ghost" className="text-white hover:bg-white/20 mb-4">
              <ArrowLeft className="h-4 w-4 mr-2" /> Zurück zur Startseite
            </Button>
          </Link>
          <div className="flex items-center gap-4">
            <Scale className="h-12 w-12" />
            <div>
              <h1 className="text-3xl font-bold">Allgemeine Geschäftsbedingungen</h1>
              <p className="text-blue-100">Dom's Pfotenexpress - Pfotenflatrate</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg p-8 space-y-8">
          
          <section>
            <h2 className="text-xl font-bold text-blue-600 mb-4 flex items-center">
              <FileText className="h-5 w-5 mr-2" /> § 1 Geltungsbereich
            </h2>
            <div className="text-gray-700 space-y-3">
              <p>(1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für alle Verträge über Haustiertransportdienstleistungen zwischen Dom's Pfotenexpress, Sternstraße 1, 58089 Hagen (nachfolgend „Anbieter") und dem Kunden (nachfolgend „Kunde"), insbesondere im Rahmen der „Dom's Pfotenflatrate".</p>
              <p>(2) Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, der Anbieter stimmt ihrer Geltung ausdrücklich schriftlich zu.</p>
              <p>(3) Verbraucher im Sinne dieser AGB ist jede natürliche Person, die ein Rechtsgeschäft zu Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch ihrer selbstständigen beruflichen Tätigkeit zugerechnet werden können (§ 13 BGB).</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-blue-600 mb-4">§ 2 Vertragsgegenstand</h2>
            <div className="text-gray-700 space-y-3">
              <p>(1) Gegenstand des Vertrages ist die Durchführung von Haustiertransporten im Rahmen der „Dom's Pfotenflatrate". Die Flatrate umfasst pro registriertem Tier und Jahr:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>3 Fahrten zum Tierarzt innerhalb des Ortsgebiets</li>
                <li>2 Fahrten zur Tierklinik (max. 1 pro Halbjahr)</li>
                <li>Je 1 Stunde Warteservice pro Fahrt inklusive</li>
              </ul>
              <p>(2) Jedes registrierte Tier erhält sein eigenes vollständiges Kontingent. Nicht genutzte Fahrten können zwischen den registrierten Tieren des Kunden übertragen werden.</p>
              <p>(3) Zusätzliche Tiere können gegen einen Aufpreis von 8,50 € pro Monat hinzugefügt werden.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-blue-600 mb-4">§ 3 Vertragsschluss</h2>
            <div className="text-gray-700 space-y-3">
              <p>(1) Der Vertrag kommt durch die Online-Registrierung und Zahlung des Mitgliedsbeitrags zustande.</p>
              <p>(2) Der Kunde gibt durch Anklicken des Bestätigungsbuttons „Zahlungspflichtig bestellen" ein verbindliches Angebot ab. Nach erfolgreicher Zahlung erhält der Kunde eine Bestätigungs-E-Mail mit seiner Mitgliedsnummer.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-blue-600 mb-4">§ 4 Preise und Zahlungsbedingungen</h2>
            <div className="text-gray-700 space-y-3">
              <p>(1) Es gelten die zum Zeitpunkt der Bestellung angegebenen Preise. Alle Preise verstehen sich als Endpreise inklusive der gesetzlichen Mehrwertsteuer.</p>
              <p>(2) Die Zahlungsoptionen sind:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Quartalsweise: 30,00 € (alle 3 Monate)</li>
                <li>Halbjährlich: 57,00 € (3,00 € Ersparnis)</li>
                <li>Jährlich: 110,00 € (10,00 € Ersparnis)</li>
              </ul>
              <p>(3) Bei jeder Fahrt fallen Standard-Anfahrtskosten an: 1,50 € innerhalb Hagen, 3,50 € außerhalb Hagen. Bei Tierklinik-Transporten zusätzlich 5,00 € Zuschlag.</p>
              <p>(4) Die Zahlung erfolgt per Überweisung oder Dauerauftrag.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-blue-600 mb-4">§ 5 Vertragslaufzeit und Kündigung</h2>
            <div className="text-gray-700 space-y-3">
              <p>(1) Die Vertragslaufzeit beträgt ein Jahr ab Vertragsbeginn.</p>
              <p>(2) Der Vertrag verlängert sich automatisch um ein weiteres Jahr, wenn er nicht spätestens 4 Wochen vor Vertragsende schriftlich gekündigt wird.</p>
              <p>(3) Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.</p>
              <p>(4) Bei Nichtinanspruchnahme der Leistungen innerhalb des Vertragszeitraums erfolgt keine Erstattung.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-blue-600 mb-4">§ 6 Pflichten des Kunden</h2>
            <div className="text-gray-700 space-y-3">
              <p>Der Kunde ist verpflichtet:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Das Haustier zum vereinbarten Termin bereitzustellen</li>
                <li>Alle relevanten Informationen zum Tier mitzuteilen (Gesundheitszustand, Besonderheiten)</li>
                <li>Die Transportfähigkeit des Tieres sicherzustellen</li>
                <li>Termine (keine Notfälle) idealerweise 7 Tage im Voraus anzumelden</li>
                <li>Den Mitgliedsbeitrag fristgerecht zu zahlen</li>
                <li>Anfallende Zusatzkosten zu begleichen</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-blue-600 mb-4">§ 7 Haftung</h2>
            <div className="text-gray-700 space-y-3">
              <p>(1) Der Anbieter haftet für Schäden am Haustier nur bei grober Fahrlässigkeit oder Vorsatz. Die Haftung ist auf vorhersehbare, vertragstypische Schäden begrenzt.</p>
              <p>(2) Der Kunde haftet für Schäden, die durch das Verhalten seines Haustieres während des Transports entstehen.</p>
              <p>(3) Die vorstehenden Haftungsbeschränkungen gelten nicht bei der Verletzung von Leben, Körper und Gesundheit.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-blue-600 mb-4">§ 8 Widerrufsrecht für Verbraucher</h2>
            <div className="text-gray-700 space-y-3 bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-400">
              <p className="font-semibold">Widerrufsbelehrung</p>
              <p>(1) Verbraucher haben das Recht, binnen 14 Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.</p>
              <p>(2) Die Widerrufsfrist beträgt 14 Tage ab dem Tag des Vertragsabschlusses.</p>
              <p>(3) Um das Widerrufsrecht auszuüben, müssen Sie uns (Dom's Pfotenexpress, Sternstraße 1, 58089 Hagen, E-Mail: doms.pfotenexpress@gmail.com, Tel: 01573 969 69 42) mittels einer eindeutigen Erklärung (z.B. E-Mail oder Brief) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.</p>
              <p>(4) Das Widerrufsrecht erlischt vorzeitig, wenn die Dienstleistung vollständig erbracht wurde und mit der Ausführung der Dienstleistung erst begonnen wurde, nachdem der Verbraucher dazu seine ausdrückliche Zustimmung gegeben hat.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-blue-600 mb-4">§ 9 Zahlungsverzug</h2>
            <div className="text-gray-700 space-y-3">
              <p>(1) Erfolgt die Zahlung nicht fristgerecht, gerät der Kunde ohne weitere Mahnung in Verzug, sofern der Fälligkeitstermin kalendermäßig bestimmt ist (§ 286 Abs. 2 Nr. 1 BGB).</p>
              <p>(2) Im Verzugsfall ist der Anbieter berechtigt, Verzugszinsen in Höhe von 5 Prozentpunkten über dem jeweiligen Basiszinssatz (§ 288 Abs. 1 BGB) zu verlangen.</p>
              <p>(3) Vor Einleitung eines gerichtlichen Mahnverfahrens wird mindestens eine schriftliche Mahnung mit einer Nachfrist von 14 Tagen versendet.</p>
              <p>(4) Bei Zahlungsverzug von mehr als 30 Tagen kann der Anbieter die Leistungserbringung bis zum vollständigen Zahlungsausgleich aussetzen.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-blue-600 mb-4">§ 10 Streitbeilegung</h2>
            <div className="text-gray-700 space-y-3">
              <p>(1) Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:</p>
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline block mb-3">https://ec.europa.eu/consumers/odr</a>
              <p>(2) Der Anbieter ist weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
              <p>(3) Bei Beschwerden oder Streitigkeiten wenden Sie sich bitte zunächst direkt an uns: doms.pfotenexpress@gmail.com</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-blue-600 mb-4">§ 11 Datenschutz</h2>
            <div className="text-gray-700 space-y-3">
              <p>(1) Die Verarbeitung personenbezogener Daten erfolgt gemäß den Bestimmungen der DSGVO und des BDSG.</p>
              <p>(2) Ausführliche Informationen zur Datenverarbeitung finden Sie in unserer Datenschutzerklärung unter:</p>
              <a href="/datenschutz" className="text-blue-600 hover:underline block">www.doms-pfotenexpress.de/datenschutz</a>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-blue-600 mb-4">§ 12 Schlussbestimmungen</h2>
            <div className="text-gray-700 space-y-3">
              <p>(1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.</p>
              <p>(2) Gerichtsstand ist, soweit gesetzlich zulässig, Hagen. Für Verbraucher gilt der gesetzliche Gerichtsstand.</p>
              <p>(3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, so wird hiervon die Wirksamkeit der übrigen Bestimmungen nicht berührt.</p>
              <p>(4) Änderungen und Ergänzungen dieser AGB bedürfen der Schriftform.</p>
            </div>
          </section>

          {/* Footer */}
          <div className="border-t pt-6 mt-8 text-center text-gray-500 text-sm">
            <p>Dom's Pfotenexpress · Inhaber: Dominique Ewerling · Sternstraße 1 · 58089 Hagen</p>
            <p>Tel: 01573 969 69 42 · E-Mail: doms.pfotenexpress@gmail.com</p>
            <p className="mt-2">Stand: Januar 2026 · Version 2.0</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AGBPage;
